import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.USER_ADMIN_DELETE || '/user/rapidoo-admin/delete')
  },

  method() {
    return 'POST'
  },

  format(payload) {
    return {
      id: payload.id
    }
  },

  parse(raw = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || "Erreur lors de la suppression de l'utilisateur",
        data: null,
      }
    }

    return {
      statusCode: 200,
      message: 'Utilisateur supprimé avec succès',
      data: raw.data,
    }
  },
}
